import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataAppender from "./DataAppender";
import DataTagger from "./DataTagger";

export default function DataTagging() {
  const SINGLE_TAB = "single";
  const DB_TAB = "db";
  const [currentTab, setCurrentTab] = useState(DB_TAB);

  function renderTab() {
    switch (currentTab) {
      case SINGLE_TAB:
        return <DataAppender />;
      case DB_TAB:
        return <DataTagger />;
      default:
        return null;
    }
  }
  return (
    <div className="card mb-4">
      <div className="card-header">
        <FontAwesomeIcon icon="tags" className="mr-1" />
        Tag Training Data
      </div>
      <div className="card-body">
        <Nav
          variant="tabs"
          onSelect={(key) => {
            setCurrentTab(key);
          }}
          defaultActiveKey={DB_TAB}
        >
          <Nav.Item>
            <Nav.Link eventKey={SINGLE_TAB}>Text input</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey={DB_TAB}>Tag data</Nav.Link>
          </Nav.Item>
        </Nav>
        {renderTab()}
      </div>
    </div>
  );
}
